@if (strategy) {
  <div class="parallel">
    <h3>Parallel-strategy</h3>
    <mat-form-field>
      <mat-label>Enter the strategy title</mat-label>
      <input matInput type="text" placeholder="" [(ngModel)]="strategy.title" autocomplete="off">
    </mat-form-field>
    <!-- <div class="child" *ngFor="let child of strategy.children; let ix = index;">
    <div class="AND keyword" *ngIf="ix > 0 && ix < strategy.children.length">AND</div>
    <div class="fx-row">
      <div class="index-col">
        <div class="index-no">{{ ix + 1 }}</div>
      </div>
      <app-strategy [strategy]="child"></app-strategy>
    </div>
  </div> -->
</div>
}
